const $ = require('jquery');
const debounce = require('lodash/debounce');
const { trackSubProductSelection } = require('./../../ecommerceGTag');
const {setDefaultSubproduct} = require("../subproducts-list/subproducts-selection");
let lastSharedPickupType = null;

$(function () {
    if($('.single-service-page').length === 0) {
        return;
    }
    const {getServicePrices} = require('./../subproducts-list/subproducts-prices');
    const {setDefaultSubproduct,selectSubproduct, getListOfSubproducts} = require("./../subproducts-list/subproducts-selection");


    setDefaultSubproduct();
    $('#serviceOrderForm').on('keydown', function(event) {
        if (event.which === 13) {
            event.preventDefault();
            return false;
        }
    });

    $(".input-button-plus").click(function () {
        var inputField = $(this).siblings('input[type="number"]');
        var currentValue = parseInt(inputField.val());
        inputField.val(currentValue + 1).change();
    });

    $(".input-button-minus").click(function () {
        var inputField = $(this).siblings('input[type="number"]');
        var currentValue = parseInt(inputField.val());
        if (currentValue > 0) {
            inputField.val(currentValue - 1).change();
        }
    });

    let updatePriceListenerElements = ['#service_id', '#people_quantity_adult', '#people_quantity_youth', '#people_quantity_children', '#type_of_transfer', '#pickup_type', '#tour_lang'];
    updatePriceListenerElements.forEach(function (element) {
        $(element).on('change',
            debounce(() => {
                getServicePrices();
            }, 400)
        );
    });
    let updatePriceAndDefaultDayElements = ['#tour_date'];
    updatePriceAndDefaultDayElements.forEach(function (element) {
        $(element).on('change',
            () => {
                getServicePrices().then(() => {
                    setDefaultSubproduct();
                });
            }
        );
    });

    $(document).on('loadPricesEvent', () => setDefaultSubproduct());

    $(document).on('change', '.subproduct.selected .subproductPrice', function () {
        updateFormSummary();
    });

    $('#serviceOrderForm').on('submit', function (event) {
        event.preventDefault();
        let redirectUrl = prepareRedirectUrl();
        trackSubProductSelection();
        window.location = redirectUrl;
    });

    $('#pickup_type').on('change', function () {
        if ($(this).val() !== null) {
            lastSharedPickupType = $(this).val();
        }
    });
});

function updateFormStructure() {
    var privacyType = $('#private_or_group').val();
    if (privacyType === 'Private') {
        $('#pickup_type').val('').attr('disabled', true);
        $('#pickup_type').parent().parent().addClass('d-none');
    } else {
        let pickupOptions = generateFormOptions();
        if (pickupOptions !== false) {
            $('#pickup_type').parent().parent().removeClass('d-none');
            $('#pickup_type').attr('disabled', false);
        }

    }
}

function updateFormSummary(currentTotalPrice = null) {
    if (!currentTotalPrice) {
        currentTotalPrice = `N/A`;
    }
    $('.form-summary #totalPrice').text(currentTotalPrice)
}

function prepareRedirectUrl() {
    var date = new Date($('#tour_date').val());
    var timestamp = date.getTime() / 1000;
    var url = '/booking/?order=1';
    url += '&localId=' + ($('#local_id').val() || '');
    url += '&sid=' + ($('#service_id').val() || '');
    url += '&ssid=' + ($('#type_of_transfer').val() || '');
    url += '&spid=' + ($('#subservice_id').val() || '');
    url += '&asid=' + $('#availability_service_id').val();
    url += '&nop=' + ($('#people_quantity_adult').val() || '');
    url += '&nop_y=' + ($('#people_quantity_youth').val() || '');
    url += '&nop_c=' + ($('#people_quantity_children').val() || '');
    url += '&from_price_checker=Y';
    url += '&d=' + timestamp;
    url += '&service_type=' + ($('#service_type').val() || '');
    url += '&private_or_group=' + ($('#private_or_group').val() || '');
    url += '&l=' + ($('#tour_lang').val() || '');
    url += '&ppt=' + ($('#pickup_type').val() || 'HOTEL');
    return url;
}


function generateFormOptions() {
    const { getSelectedSubproduct } = require('./../subproducts-list/subproducts-selection');
    let options = getSelectedSubproduct().pick_up_types_options_for_shared;

    if (options === 'N' || options.length === 0) {
        return false;
    }

    let select = $('#pickup_type');
    select.empty();
    for (var i = 0; i < options.length; i++) {
        let formattedOption = options[i].replace(/_/g, ' ');
        if(formattedOption === 'HOTEL') {
            formattedOption = 'Hotel or pickup address';
        }
        formattedOption = formattedOption.toLowerCase().replace(/\b\w/g, function (char) {
            return char.toUpperCase();
        });
        if (options[i] === lastSharedPickupType) {
            select.append('<option selected value="' + options[i] + '">' + formattedOption + '</option>');
            continue;
        }
        select.append('<option value="' + options[i] + '">' + formattedOption + '</option>');
        select.change(); // @TODO: check if this is necessary or not. Probably is duplicate event
    }

    return true;
}

module.exports = {updateFormStructure, updateFormSummary, prepareRedirectUrl, generateFormOptions};
